define ['./rejectApplicationModal.css'], () ->
  ($scope, $rootScope, $uibModalInstance, RentappService, $http, RENTAPPLICATION_API_URL, Flash) ->
    $scope.theme_color = $rootScope.THEME_COLOR



// WEBPACK FOOTER //
// ./directives/acceptRejectApplication/rejectApplication/rejectApplicationModal/rejectApplicationModal.coffee